import { IBreadcrumb } from '../../types/buildersProjects/breadcrumbs';
import { IApplicationState } from '../../types/redux';

export const selectBreadcrumbs = (state: IApplicationState): IBreadcrumb[] => {
  return state.buildersProjects.data.breadcrumbs;
};
